module.exports = {"id":"199383","name":"Timm Klose","rating":"74","photo":"./data/images/photos/3/199383.png","club":{"name":"Norwich City","logo":"./data/images/clubs/NorwichCity.png"},"positions":["DC"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/TimmKlose0.json
// module id = 4136
// module chunks = 0